import clsx from "clsx";
import parse from "html-react-parser";
import Image from 'next/image'

import SocialLinks from "@components/SocialLinks";
import DotBorder from "./DotBorder";

const Profile = ({
	heading,
	image,
	imageBlur,
	socialLinks,
	role,
	biography,
	aspectRatio = "square",
}) => {
	return (
		<div className={clsx("Profile", "max-w-screen-lg mx-auto relative")}>
			<div
				className={clsx(
					"Profile__content",
					"flex flex-col lg:flex-row",
					"mx-auto bg-white-02 relative box-sizing"
				)}
			>
				<div className={clsx("Profile__imageWrapper", "relative", "lg:w-1/2")}>
					{!!image?.url && (
						<div className={clsx("max-w-[450px]")}>
							<Image
								src={image.url}
								alt={image.title}
								layout={"responsive"}
								width={image.width}
								height={image.height}
								placeholder="blur"
								blurDataURL={imageBlur.url}
								className={clsx("Profile__image")}
							/>
						</div>
					)}
					{!image && (
						<div
							className={clsx("aspect-w-16 aspect-h-10", "bg-white-03")}
						></div>
					)}
				</div>

				<div
					className={clsx(
						"Profile__body",
						"lg:w-1/2 px-5 py-5 lg:pl-0 lg:pt-12 lg:pr-12"
					)}
				>
					<div className={clsx("Profile__header", "pb-7")}>
						<h1
							className={clsx(
								"Profile__heading",
								"text-2xl lg:text-xl font-medium",
								"pb-2"
							)}
						>
							{heading}
						</h1>
						{!!role && (
							<div className={clsx("Profile__role", "text-xl")}>{role}</div>
						)}
						{!!socialLinks && (
							<div className={clsx("Profile__socialLinks")}>
								<SocialLinks links={socialLinks} />
							</div>
						)}
          </div>
          {!!biography && (
            <div className={clsx("Profile__biography", "prose text-sm")}>
              {parse(biography)}
            </div>
          )}
				</div>
			</div>
			<DotBorder />
		</div>
	);
};

export default Profile;
